import { schema } from '@Schema/schema';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/incidents/visual/')({
  validateSearch: zodValidator(schema.VISUAL_EXPLORER),
});
